import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';

function getChannelValueWithUnitsFromChannelKeyObjectString(
  tempScale, channelKey, value, customUnits,
) {
  const channel = ChannelService.getChannelGroupChannel(
    channelKey.channelGroupType,
    channelKey.channelIndex,
    channelKey.channelType,
  );
  return `${channel.getDisplayValue(value, { scale: tempScale })} ${channel.getUnits({ scale: tempScale, customUnits })}`;
}

export default getChannelValueWithUnitsFromChannelKeyObjectString;
